const STORAGE_KEY = "camerito-motion-algorithm";

const ALGORITHMS = ["diff", "lucas-kanade", "three-frame"] as const;
export type MotionAlgorithm = (typeof ALGORITHMS)[number];

type AlgorithmListener = (algorithm: MotionAlgorithm) => void;
const listeners = new Set<AlgorithmListener>();

export const getMotionAlgorithm = (): MotionAlgorithm => {
  const stored = localStorage.getItem(STORAGE_KEY) as MotionAlgorithm | null;
  return stored && ALGORITHMS.includes(stored) ? stored : "diff";
};

const setMotionAlgorithm = (algorithm: MotionAlgorithm) => {
  if (!ALGORITHMS.includes(algorithm)) {
    log.warn("Unknown motion algorithm:", algorithm, "- expected one of:", ALGORITHMS.join(", "));
    return;
  }
  localStorage.setItem(STORAGE_KEY, algorithm);
  log.motion("Motion algorithm set to:", algorithm);
  listeners.forEach((listener) => listener(algorithm));
};

export const onMotionAlgorithmChange = (listener: AlgorithmListener) => {
  listeners.add(listener);
};

const OVERLAY_STORAGE_KEY = "camerito-motion-overlay";

type OverlayListener = (enabled: boolean) => void;
const overlayListeners = new Set<OverlayListener>();

export const getMotionOverlayEnabled = () => localStorage.getItem(OVERLAY_STORAGE_KEY) === "true";

const setMotionOverlayEnabled = (enabled: boolean) => {
  localStorage.setItem(OVERLAY_STORAGE_KEY, String(enabled));
  log.motion("Motion debug overlay set to:", enabled);
  overlayListeners.forEach((listener) => listener(enabled));
};

export const onMotionOverlayChange = (listener: OverlayListener) => {
  overlayListeners.add(listener);
};

window.motionDebug = {
  getAlgorithm: getMotionAlgorithm,
  getAvailableAlgorithms: () => ALGORITHMS,
  setAlgorithm: setMotionAlgorithm,
  getOverlay: getMotionOverlayEnabled,
  setOverlay: setMotionOverlayEnabled
};
